module.exports = {
  EnrichedAudio: {
    Allow_fullscreen: "Allow fullscreen",
    Show_controls: "Show Controls",
    Autoplay: "Autoplay",
    Waves: "Waves",
    WaveColor: "Wave color",
    ProgressColor: "Progress color",
    BarWidth: "Bar width",
    URL: "URL",
    Audio: "Audio",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    PluginName: "Audio Player",
    player: "Player style",
    radius: "Radius",
    pos: "Position",
    source: "Source",
    Scroll: "Scroll",
    message_mark_error:
      "You've chosen an incorrect value. You must introduce a time like in the format of h:mm:ss or mm:ss. E.g. 1:33",
  },
};
